"use client";

import { motion } from "framer-motion";
import { Users2, Zap, Brain, LucideIcon } from "lucide-react";
import { BenefitCard } from "@/components/ui/benefit-card";
import { cn } from "@/lib/utils";

const motionVariants = {
  stagger: {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  },
  fadeInUp: {
    hidden: { opacity: 0, y: 20 },
    show: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.6 }
    }
  }
};

export function AboutBeliefs() {
  const iconMap: Record<string, LucideIcon> = {
    Users2,
    Zap,
    Brain,
  };

  const content = {
    title: "Unsere Kernüberzeugungen",
    benefits: [
      {
        title: "KI für Menschlichkeit",
        description: "KI kann und soll repetitive Aufgaben übernehmen – damit Menschen sich auf wertvolle Beziehungen konzentrieren können.",
        icon: "Users2",
        iconColor: "text-primary"
      },
      {
        title: "Skalierbare Empathie",
        description: "Jeder Kandidat verdient die gleiche Aufmerksamkeit und die gleiche Wertschätzung – unabhängig von verfügbaren Ressourcen.",
        icon: "Zap",
        iconColor: "text-primary"
      },
      {
        title: "Nachhaltige Beziehungen",
        description: "Recruiting ist der Startpunkt einer wertvollen, dauerhaften Verbindung. Wir glauben daran, dass echte Partnerschaften entstehen, wenn Technologie und menschliche Sorgfalt Hand in Hand gehen.",
        icon: "Brain",
        iconColor: "text-primary"
      }
    ]
  };

  const { title, benefits = [] } = content;
  const textColor = "text-primary";

  return (
    <section className="py-24 bg-background">
      <div className="container mx-auto px-4">
        <motion.div
          variants={motionVariants.fadeInUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className={cn(
            "text-h2 mb-2"
          )}>
            {title}
          </h2>
          <div className={cn(
            "w-24 h-1 mx-auto rounded-full",
            textColor
          )} />
        </motion.div>

        <motion.div
          variants={motionVariants.stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto items-stretch"
        >
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              variants={motionVariants.fadeInUp}
              className="h-full"
            >
              {iconMap[benefit.icon] && (
                <BenefitCard
                  title={benefit.title}
                  description={benefit.description}
                  icon={iconMap[benefit.icon]}
                  iconColor={benefit.iconColor}
                  className="h-full"
                />
              )}
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
} 